import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
} from 'reactstrap';

const AddCommentModal = ({ isOpen, toggle, onSubmit, actionType = "update" }) => {
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Reset form when modal opens/closes
  useEffect(() => {
    if (isOpen) {
      setNote('');
      setError('');
    }
  }, [isOpen]);

  // Handle input change
  const handleChange = (e) => {
    setNote(e.target.value);
    if (error) {
      setError('');
    }
  };

  // Validate form
  const validateForm = () => {
    if (!note.trim()) {
      setError('Note is required');
      return false;
    }
    return true;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      await onSubmit(note.trim());
      toggle();
    } catch (err) {
      setError('An error occurred while processing your request');
      console.error('Comment submission error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="md">
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          <span className="fw-bold">Add Note</span>
        </ModalHeader>
        
        <ModalBody>
          {error && (
            <Alert color="danger" className="mb-3">
              {error}
            </Alert>
          )}
          
          <FormGroup>
            <Label for="note" className="fw-bold">
              Add Note for your action <span className="text-danger">*</span>
            </Label>
            <Input
              id="note"
              name="note"
              type="textarea"
              value={note}
              onChange={handleChange}
              placeholder="Please provide a reason or Note for this action..."
              rows={4}
              invalid={!!error}
            />
            {error && (
              <div className="text-danger small mt-1">
                {error}
              </div>
            )}
          </FormGroup>
        </ModalBody>
        
        <ModalFooter>
          <Button 
            type="button" 
            color="secondary" 
            onClick={toggle}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button 
            type="submit" 
            color="primary"
            disabled={loading}
          >
            {loading ? (
              <span className="d-flex align-items-center">
                {/* <Spinner size="sm" className="me-2" /> */}
                Processing...
              </span>
            ) : (
              'Submit'
            )}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddCommentModal;